export enum EventCategory {
  Credentials = 'lopes:credenciais',
  General = 'lopes:geral',
  Home = 'lopes:home',
  Form = 'lopes:formulario',
  ProductLeadForm = 'lopes:ecommerce:fale-com-o-corretor',
  SearchEngine = 'lopes:motor-busca',
  ProductGrid = 'lopes:ecommerce:vitrine',
  Calculator = 'lopes:calculadora-potencial-compra',
  Product = 'lopes:imovel',
  SearchResult = 'lopes:resultado-busca'
}
